/* eslint-disable no-unused-vars */
enum GenderInfo {
  Female = 'female',
  Male = 'male',
  NonFemale = 'non-female',
  NonMale = 'non-male',
}

export default GenderInfo;
